Monitor = require 'app/scripts/lib/monitor'

module.exports.markNotificationsReadOnActive = ->
  if Monitor.getStatus() == 'active' || !Monitor.getHidden()
    @markRelatedNotificationsRead()

module.exports.markRelatedNotificationsRead = ->
  relatedNotifications = @modelCache.all('Notification')
    .filter((notification) => notification.get('data')?.card?.id == @model.id)
  if relatedNotifications.length > 0
    unreadNotifications = relatedNotifications.filter((notification) -> notification.get('unread'))
    if unreadNotifications.length > 0
      # mark as read to update the UI
      # server update is handled via markAssociatedNotificationsRead
      unreadNotifications.forEach((notification) -> notification.set({ unread: false }))
    else
      # Return early, we know all related notifications are already marked as read
      return

  @model.markAssociatedNotificationsRead()
